import { FC } from 'react';

import { Copy } from 'lucide-react';

import Button from '@mui/material/Button';

import css from '../DistributionLinkPage.module.css';

import { DistributionLinkModel } from 'v2/types/DistributionLinkModel';
import { copyText } from 'v2/utils';

interface DistributionLinkUrlColumnProps {
  distributionLink: DistributionLinkModel;
}

export const DistributionLinkUrlColumn: FC<DistributionLinkUrlColumnProps> = ({ distributionLink }) => {
  const handleCopy = () => {
    copyText(distributionLink.url);
  };

  return (
    <Button
      className={css.distributionLinkTableUrlColumn}
      onClick={handleCopy}
      endIcon={<Copy width={14} height={14} />}
    >
      {distributionLink.url}
    </Button>
  );
};
